import React from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import FormSection from './components/FormSection'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './styles/index.scss'

function App() {
  return (
    <Router>
      <ToastContainer theme='light' draggable={false}/>
      <Routes>
        <Route path='/*' element={<FormSection/>} />
      </Routes>
    </Router>
  )
}

export default App
